import { render, staticRenderFns } from "./reservationIndex.vue?vue&type=template&id=514c4ec0&scoped=true"
import script from "./reservationIndex.vue?vue&type=script&lang=js"
export * from "./reservationIndex.vue?vue&type=script&lang=js"
import style0 from "./reservationIndex.vue?vue&type=style&index=0&id=514c4ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c4ec0",
  null
  
)

export default component.exports